module.exports = __webpack_public_path__ + "img/ios.c01358d1.png";